<template>
  <div class="card">
    <header class="bandeau-modal card-header"/>
    <div class="card-content pd-40px">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{$t('listeJournalEcriture.actions.libellePopupAssocieLot')}}
        </p>
        <error-msg-component :messages="messages"
                             :error="messages.length > 0"
                             :withEmplyFields="true"
                             @close="messages = []"/>
      </section>
      <div class="mgb-40px">
        <b-field :label="$t('listeJournalEcriture.actions.labelPopupLot')">
          <b-autocomplete
            :data="listeLots"
            icon="magnify"
            field="libelle"
            :loading="isFetching"
            :check-infinite-scroll="true"
            @typing="getAsyncData"
            @select="getSelected"
            @infinite-scroll="getMoreAsyncData"
            ref="libelleInput">
              <template slot="empty">{{$t('listeJournalEcriture.actions.noResult')}}</template>
          </b-autocomplete>
        </b-field>
      </div>
      <div class="buttons">
        <qd-button type="is-light"
                  class="btn-modal-annuler"
                  @click="close()">
          {{$t('listeJournalEcriture.actions.boutonPopupClose')}}
        </qd-button>
        <qd-button type="is-info"
                  @click="save()">
          {{$t('listeJournalEcriture.actions.applique')}}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/compta/ifLot/index';
import { insertIntoIfLot } from '@/api/compta/ifEcriture/index';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/compta/journal/validation';
import { ACTIF } from '@/configuration/compta/lotConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    ecritures: Array,
  },
  components: {
    errorMsgComponent,
  },
  data: () => ({
    lotSelect: null,
    messages: [],
    listeLots: [],
    isFetching: false,
    libelle: '',
    page: 1,
    totalPages: 1,
  }),
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    label() {
      return '';
    },
  },
  methods: {
    close(val) {
      this.$emit('close', val);
    },
    async save() {
      if (!this.lotSelect) {
        this.messages.push({
          message: 'listeJournalEcriture.msgError.libelleObligatoire',
        });
        this.error = true;
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        await insertIntoIfLot({
          ifLotId: this.lotSelect.id,
          ifEcrituresIds: this.ecritures,
        });
        messageSucces(this.$t('listeJournalEcriture.actions.associeSuccess'));
        this.$emit('save');
        this.close(true);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messages, this.$i18n);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    getAsyncData: debounce(async function get(libelle) {
      try {
        if (this.libelle !== libelle) {
          this.libelle = libelle;
          this.listeLots = [];
          this.page = 1;
          this.totalPages = 1;
        }
        if (!libelle.length) {
          this.listeLots = [];
          this.page = 1;
          this.totalPages = 1;
          return;
        }
        if (this.page > this.totalPages) {
          return;
        }
        this.isFetching = true;
        const result = await getAll({
          query: {
            societeId: this.societeActiveId,
            auto: this.libelle,
            etat: ACTIF,
          },
          page: this.page,
          limit: 10,
        });
        result.data.result.items.forEach((item) => this.listeLots.push(item));
        this.page += 1;
        this.totalPages = result.data.result.totalCount;
        this.isFetching = false;
      } catch (error) {
        this.isFetching = false;
        throw error;
      }
    }, 500),
    getMoreAsyncData: debounce(function getMore() {
      this.getAsyncData(this.libelle);
    }, 250),
    getSelected(lotSelect) {
      this.lotSelect = lotSelect;
    },
  },
  mounted() {
    this.$refs.libelleInput.focus();
  },
};
</script>

<style>

</style>
